import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import "./Spinner.scss";

const propTypes = {
  /**
   * Size of the spinner
   */
  size: PropTypes.oneOf(["medium", "small", "extraSmall"]),
  /**
   * Color of the spinner
   */
  color: PropTypes.oneOf(["primary", "light"]),
  /**
   * Class to override default styles
   */
  className: PropTypes.string,
};

const defaultProps = {
  size: "medium",
  color: "primary",
  className: "",
};

/**
 * Loading spinner
 */
function Spinner(props) {
  const { size, color, className } = props;

  return (
    <svg
      className={clsx(
        "Uic-Spinner-spin",
        `Uic-Spinner-${size}`,
        `Uic-Spinner-${color}`,
        className
      )}
      viewBox="0 0 50 50"
      role="status"
    >
      <circle
        className="Uic-Spinner-path"
        cx="25"
        cy="25"
        r="20"
        fill="none"
        strokeWidth="5"
      />
    </svg>
  );
}

Spinner.defaultProps = defaultProps;
Spinner.propTypes = propTypes;

export default Spinner;
